import StorageUtil from "./storageUtil";
import CommonUtil from "./utility";
import { authProps } from "./viewUtility";
import { UserDataInterface } from "../types";

export const AuthService = {
	isAuthenticated(): boolean {
		return !!StorageUtil.getData(authProps.SECURITY_TOKEN);
	},
	getUserData(): UserDataInterface | null {
		const user = StorageUtil.getData(authProps.USER_DATA);
		if (CommonUtil.isNotNull(user)) {
			return JSON.parse(user as string);
		}
		return null;
	},
};
export default AuthService;
